export default {
  getPours: (state) => state.pours,
  getPourById: (state) => (gid) => state.pours.find((_p) => _p.gid === gid),
}
